export default{
	getAppKey() {
		if(process.env.buildType == "18hd"){
			return "6FFD5D368CE5B5AA"
		}else{
			return "4B84DC5B4744488831B3E31D0F4B8F8C"
		}
	}
}


// WEBPACK FOOTER //
// ./src/api/appkey.js